import { gql } from '__generated__';

export default gql(`
  query GetDashboardStats($project_id: ID!, $since: String!, $page: Int) {
    project(id: $project_id) {
      events(page: $page, per_page: 10) {
        data {
          id
          title
          start_date
          end_date
          registrations_count
          new_registrations_count: registrations_count(since: $since)
          logo {
            url
          }
        }
        current_page
        last_page
        per_page
        total
      }
      analytics {
        monthly_registration_counts {
          year
          month
          count
        }
      }
    }
  }
`);
